import { NotFound } from '@/components/pages'
import { Page } from '@/core/architecture'

import { QRcodeGetItemMultiTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * QRcodeGetItemMulti Page
 * Implemented as a practical sample.
 */
export const QRcodeGetItemMulti: Page = () => {
  const { state, actions } = useViewModel()

  if (!state.loading && !state.multiItemSerial) {
    return <NotFound useNextRouter={false} />
  }

  return <QRcodeGetItemMultiTemplate state={state} {...actions} />
}
